var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftGreetingIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 221,
    viewBox: "0 0 73 221",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-34.9043 0.898251C-34.9043 0.898251 127.069 48.5794 51.6617 90.9802C-23.7457 133.381 118.263 170.288 -84.2351 219.93",
    stroke: "#4ECE3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-24.9043 0.898251C-24.9043 0.898251 137.069 48.5794 61.6617 90.9802C-13.7457 133.381 128.263 170.288 -74.2351 219.93",
    stroke: "#4ECE3D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftGreetingIcon);
export default __webpack_public_path__ + "static/media/leftGreetingIcon.a13b2a3ba4f49c2a870cdfd0413d9bc4.svg";
export { ForwardRef as ReactComponent };